var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentCardImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 119,
    viewBox: "0 0 162 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2415_78708)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9989 5.12173C73.1085 2.90002 92.4318 -6.06107 104.498 5.122C117.013 16.7203 118.345 36.2784 114.934 53.1593C111.886 68.2512 100.657 79.0843 87.9025 87.2711C75.0616 95.5133 58.0251 106.048 43.4991 101.498C28.2887 96.7332 8.908 87.2984 3.49895 71.9977C-2.00701 56.4229 1.14441 33.9716 10.499 20.498C19.4214 7.64704 41.7106 7.23018 56.9989 5.12173Z",
    fill: "#A78D78",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3254 30.4222C65.1205 38.6917 46.9305 46.3358 43.0694 62.5586C39.065 79.3839 49.3753 95.4787 62.2097 106.539C73.684 116.426 89.7222 117.91 105.527 116.381C121.439 114.841 137.979 110.823 147.85 98.2501C158.185 85.0853 159.885 67.9185 155.587 52.6154C151.213 37.0382 141.241 22.5591 125.273 17.8504C110.043 13.3593 94.7553 22.5742 80.3254 30.4222Z",
    fill: "#A78D78",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2415_78708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.886 70.9482C106.886 73.9437 104.471 76.3713 101.493 76.3713H21.2672C18.2896 76.3713 15.875 73.9437 15.875 70.9482V25.5288C15.875 22.533 18.2896 20.1055 21.2672 20.1055H101.493C104.471 20.1055 106.886 22.533 106.886 25.5288L106.886 70.9482Z",
    fill: "#050505",
    stroke: "#DAD8FF",
    strokeWidth: 0.306411,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.857 60.0968C104.41 65.0816 103.888 68.8296 98.9283 70.9047C92.4577 73.6124 85.5634 73.0567 78.6862 73.4414C74.2503 73.6887 69.4705 74.4118 65.0554 74.8877C63.0307 75.106 60.4952 75.4997 58.5703 75.9808H101.492C104.251 75.9808 106.495 73.7241 106.495 70.9506V40.1562C105.558 46.5973 105.443 53.5472 104.857 60.0968Z",
    fill: "#E1E0E1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.886 29.3125H15.875V39.2033H106.886V29.3125Z",
    fill: "#A78D78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6635 50.2525C67.455 51.2074 66.675 51.9549 65.6446 51.9549C65.6427 51.9549 22.5611 51.9549 22.4883 51.9549C19.6966 51.954 19.854 44.5312 22.4883 44.5312C22.4883 44.5312 65.5063 44.5312 65.6446 44.5312C66.8533 44.5312 67.5256 45.7567 67.6514 46.7597C67.7486 47.533 67.9262 49.0552 67.6635 50.2525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.244 50.3398C101.911 51.2646 100.98 51.9549 100.367 51.9549C100.359 51.9549 73.6273 51.9549 73.5657 51.9549C70.8002 51.954 70.917 44.5312 73.5657 44.5312C73.5721 44.5312 100.252 44.5312 100.367 44.5312C102.415 44.5312 103.025 48.1586 102.244 50.3398Z",
    fill: "white",
    stroke: "#050505",
    strokeWidth: 0.0105726,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.367 66.9076C102.367 67.631 101.636 68.2171 101.354 68.2171H81.4586C81.1795 68.2171 80.5117 67.631 80.5117 66.9076C80.5117 66.1842 81.1795 65.5977 81.4586 65.5977H101.354C101.636 65.5977 102.367 66.1841 102.367 66.9076Z",
    fill: "white",
    stroke: "#050505",
    strokeWidth: 0.00557439,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3203 66.9076C52.3143 67.562 51.8432 68.2171 51.2626 68.2171C51.2582 68.2171 21.2175 68.2171 21.2175 68.2171C20.7938 68.2171 20.125 67.631 20.125 66.9076C20.125 66.1842 20.7936 65.5977 21.2175 65.5977C21.2175 65.5977 51.1983 65.5977 51.2626 65.5977C51.8677 65.5977 52.3266 66.252 52.3203 66.9076Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2415_78708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.954 92.8335C153.954 95.8299 151.539 98.258 148.559 98.258H68.335C65.357 98.258 62.9414 95.8299 62.9414 92.8335V47.4152C62.9414 44.4197 65.3569 41.9922 68.335 41.9922H148.559C151.539 41.9922 153.954 44.4197 153.954 47.4152V92.8335Z",
    fill: "#7D634F",
    stroke: "#D9D7FF",
    strokeWidth: 0.459619,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.922 81.9832C151.477 86.9688 150.955 90.7165 145.995 92.7916C139.524 95.4988 132.631 94.9441 125.753 95.3278C121.316 95.5759 116.536 96.2981 112.122 96.7735C110.097 96.9913 107.561 97.3861 105.637 97.8672H148.558C151.318 97.8672 153.563 95.611 153.563 92.836V62.043C152.625 68.4836 152.508 75.4336 151.922 81.9832Z",
    fill: "#525252"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.718 90.0786C143.322 91.1798 142.21 92.002 141.482 92.002C141.472 92.002 128.495 92.002 128.423 92.002C125.129 92.0012 125.267 83.1602 128.423 83.1602C128.43 83.1602 141.344 83.1602 141.482 83.1602C143.92 83.1602 144.648 87.4815 143.718 90.0786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.133 90.7562C116.133 91.4442 115.663 92.0008 115.082 92.0008H73.8385C73.2584 92.0008 72.7891 91.4442 72.7891 90.7562C72.7891 90.0688 73.2584 89.5117 73.8385 89.5117H115.082C115.663 89.5119 116.133 90.0688 116.133 90.7562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.79 84.4047C121.79 85.0916 121.258 85.6492 120.602 85.6492H73.9759C73.3194 85.6492 72.7891 85.0918 72.7891 84.4047C72.7891 83.7172 73.3194 83.1602 73.9759 83.1602H120.602C121.258 83.1602 121.79 83.7172 121.79 84.4047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1951 60.217C95.1951 60.8685 94.6697 61.3974 94.0217 61.3974H76.5682C75.9199 61.3974 75.3945 60.8685 75.3945 60.217V50.3353C75.3945 49.6846 75.9199 49.1562 76.5682 49.1562H94.0217C94.6697 49.1562 95.1951 49.6846 95.1951 50.3353V60.217Z",
    fill: "#BABEC1",
    stroke: "#9B9D9D",
    strokeWidth: 0.459619,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8008 52.8242H94.7925",
    stroke: "#9B9D9D",
    strokeWidth: 0.459619,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7969 57.0508H94.7886",
    stroke: "#9B9D9D",
    strokeWidth: 0.459619,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.293 49.1562V61.3972",
    stroke: "#9B9D9D",
    strokeWidth: 0.459619,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.452 50.4922H121.334C122.137 50.4922 122.753 50.6008 123.179 50.8182C123.822 51.1501 124.144 51.7486 124.144 52.6134C124.144 53.1395 123.994 53.5673 123.697 53.8997C123.537 54.0851 123.275 54.2671 122.913 54.4449C123.919 54.7286 124.421 55.3951 124.421 56.4454C124.421 57.3675 124.115 58.0151 123.504 58.3865C123.046 58.6612 122.355 58.7985 121.429 58.7985H119.452C119.347 58.7985 119.279 58.7836 119.247 58.7502C119.214 58.7184 119.199 58.6488 119.199 58.5447V50.7455C119.199 50.5764 119.282 50.4922 119.452 50.4922ZM120.827 53.9232H121.201C122.077 53.9232 122.515 53.5436 122.515 52.7834C122.515 52.104 122.122 51.7645 121.334 51.7645H120.827V53.9232ZM120.827 57.5248H121.261C121.752 57.5248 122.109 57.4566 122.335 57.3192C122.639 57.1415 122.793 56.8177 122.793 56.3488C122.793 55.8879 122.644 55.5686 122.346 55.3908C122.122 55.2607 121.767 55.1963 121.285 55.1963H120.827L120.827 57.5248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.292 58.5797L129.376 58.9558C129.247 58.9881 129.195 59.0044 129.219 59.0044C129.171 59.0044 129.109 58.923 129.033 58.7621C128.956 58.5998 128.901 58.4383 128.869 58.2769C128.387 58.7621 127.864 59.0044 127.301 59.0044C126.747 59.0044 126.307 58.8367 125.981 58.5012C125.656 58.1662 125.492 57.7114 125.492 57.1372C125.492 56.2555 125.899 55.6572 126.711 55.3426C127.152 55.1721 127.797 55.0875 128.64 55.0875V54.7114C128.64 54.3876 128.582 54.1577 128.466 54.0203C128.348 53.8827 128.122 53.8139 127.784 53.8139C127.518 53.8139 127.206 53.875 126.844 53.9958C126.481 54.1168 126.297 54.1778 126.289 54.1778C126.233 54.1778 126.192 54.1377 126.168 54.0564L125.926 53.3171C125.903 53.2681 125.891 53.2198 125.891 53.1716C125.891 53.0343 126.127 52.9047 126.596 52.7834C127.067 52.6619 127.538 52.6016 128.013 52.6016C129.397 52.6016 130.087 53.2523 130.087 54.554V56.8947C130.087 57.3639 130.192 57.8891 130.401 58.4711C130.401 58.5111 130.365 58.5479 130.292 58.5797ZM128.64 57.4153V56.0812C128.198 56.0812 127.876 56.1103 127.675 56.1667C127.184 56.304 126.939 56.5991 126.939 57.052C126.939 57.2861 127.016 57.483 127.168 57.6398C127.321 57.7967 127.511 57.8763 127.736 57.8763C128.032 57.8764 128.335 57.7236 128.64 57.4153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.505 54.3722V58.6289C136.505 58.7427 136.45 58.7985 136.337 58.7985H135.142C135.03 58.7985 134.973 58.7425 134.973 58.6289V54.8933C134.973 54.2141 134.749 53.8753 134.299 53.8753C133.945 53.8753 133.591 54.0408 133.237 54.3722V58.6289C133.237 58.7427 133.181 58.7985 133.068 58.7985H131.874C131.761 58.7985 131.705 58.7425 131.705 58.6289V54.9674C131.705 54.279 131.667 53.7861 131.591 53.4874C131.515 53.1882 131.477 53.05 131.477 53.074C131.477 53.0177 131.52 52.9735 131.609 52.9412L132.526 52.6375C132.598 52.6134 132.658 52.6016 132.707 52.6016C132.834 52.6016 132.964 52.8807 133.092 53.4372C133.712 52.8807 134.326 52.6016 134.939 52.6016C135.983 52.6017 136.505 53.1918 136.505 54.3722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.1 55.4407L143.295 58.0966C143.368 58.1703 143.404 58.2298 143.404 58.2789C143.404 58.3281 143.383 58.363 143.343 58.3881L142.311 58.9578C142.254 58.9901 142.206 59.0065 142.166 59.0065C142.133 59.0065 142.085 58.9666 142.02 58.8851L139.797 55.9871V58.6306C139.797 58.7444 139.742 58.8002 139.629 58.8002H138.435C138.322 58.8002 138.266 58.7442 138.266 58.6306V50.4805C138.266 50.3677 138.343 50.2954 138.495 50.2627L139.509 50.0563C139.581 50.0326 139.645 50.0195 139.701 50.0195C139.765 50.0195 139.797 50.1046 139.797 50.2751V55.0775L142.113 52.7246C142.178 52.644 142.234 52.6036 142.282 52.6036C142.323 52.6036 142.394 52.6481 142.5 52.7373L143.102 53.2344C143.142 53.2749 143.162 53.3195 143.162 53.3681C143.162 53.3999 143.127 53.4532 143.054 53.5259L141.1 55.4407Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2415_78708",
    x: 12.0896,
    y: 19.9531,
    width: 98.582,
    height: 63.8366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.63218
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.81609
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.154607 0 0 0 0 0.132258 0 0 0 0 0.59042 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2415_78708"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2415_78708",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2415_78708",
    x: 59.0794,
    y: 41.7617,
    width: 98.7363,
    height: 63.9909,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.63218
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.81609
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.154607 0 0 0 0 0.132258 0 0 0 0 0.59042 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2415_78708"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2415_78708",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2415_78708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 119,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCardImg);
export default __webpack_public_path__ + "static/media/payment-card-img.6284267c7cc2d36f86cf7026f0b5e61c.svg";
export { ForwardRef as ReactComponent };